export default __webpack_public_path__ + "static/media/years_in_position.57c8c6d5.svg";